var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class:
        "c-gallery-image-scroller " +
        (_vm.controlsLiveRegion
          ? "c-gallery-image-scroller--controls-live-region"
          : "")
    },
    [
      _vm.$resize && _vm.$mq.above(1024)
        ? _c("div", {
            staticClass:
              "c-gallery-image-scroller__thumbnail-nav c-gallery-image-scroller__thumbnail-nav--left"
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "c-gallery-image-scroller__image-row",
          class: { "has-intro": _vm.hasSlot }
        },
        [
          _vm._t("intro"),
          _vm._v(" "),
          _c(
            "VueSlickCarousel",
            _vm._b(
              {
                ref: "carousel",
                on: {
                  reInit: _vm.onInitCarousel,
                  afterChange: _vm.afterChange
                },
                scopedSlots: _vm._u([
                  {
                    key: "customPaging",
                    fn: function(page) {
                      return [
                        _c(
                          "div",
                          {
                            staticClass:
                              "c-gallery-image-scroller__pagination--dot"
                          },
                          [_vm._v("\n\t\t\t\t\t\t \n\t\t\t\t\t")]
                        )
                      ]
                    }
                  }
                ])
              },
              "VueSlickCarousel",
              _vm.settings,
              false
            ),
            _vm._l(_vm.images, function(image, index) {
              return _c("v-object-development", {
                key: index,
                attrs: {
                  image: image,
                  readMoreLabel: _vm.readMoreLabel,
                  headingLevel: _vm.headingLevel
                }
              })
            }),
            1
          )
        ],
        2
      ),
      _vm._v(" "),
      _vm.$resize && _vm.$mq.above(1024)
        ? _c("div", {
            staticClass:
              "c-gallery-image-scroller__thumbnail-nav c-gallery-image-scroller__thumbnail-nav--right"
          })
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }